/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Liste } from '@mairistem/liste';
import { DateInput } from '@mairistem/composants';

import type { Individu } from '@/types';

import RecenseListeTable from './RecenseListeTable';

interface RecenseListeProps {
  recenses?: Array<Individu>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSearch?: any;
  onSort?: any;
  onExplored?: any;
  onExpanded?: any;
  state?: any;
  mode?: 'expander' | 'explorer';
  dateNaissance?: Date | null;
  onDateChange?: (value: Date | null) => void;
  simplified?: boolean;
  onSelect?: (item: Partial<Individu>) => void;
  defaultSearch?: string;
  onSearchChange?: (value: string) => void;
  typeRecensement?:
    | 'all'
    | 'recenses'
    | 'recenses-regularises'
    | 'non-recenses'
    | 'recenses-recenses-regularises';
  displayRecensement?: boolean;
}

const getListeTitle = (typeRecensement) => {
  switch (typeRecensement) {
    case 'non-recenses':
      return 'Liste des non recensés';
    case 'recenses-regularises':
      return 'Liste des recensés régularisés';
    case 'recenses-recenses-regularises':
      return 'Liste des recensés';
    case 'all':
      return 'Liste des recensés et non recensés';
    case 'recenses':
    default:
      return 'Liste des recensés';
  }
};

const RecenseListe = (props: RecenseListeProps) => {
  const {
    recenses,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    mode,
    dateNaissance,
    onDateChange,
    simplified,
    onSelect,
    defaultSearch,
    onSearchChange,
    typeRecensement,
    displayRecensement,
    ...handlers
  } = props;

  const handleSearch = React.useCallback(
    (value: string) => {
      onSearchChange?.(value);
      handlers.onSearch?.(value);
    },
    [onSearchChange, handlers.onSearch],
  );

  return (
    <Liste
      title={getListeTitle(typeRecensement)}
      mode={mode}
      searchable
      search={{ clearable: true, value: defaultSearch }}
      {...handlers}
      onSearch={handleSearch}
    >
      {simplified && (
        <Liste.Header>
          <div
            className="recense-date-naissance"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginTop: '-1rem',
            }}
          >
            <b>Date de naissance</b>
            <DateInput value={dateNaissance} onChange={onDateChange} />
          </div>
        </Liste.Header>
      )}
      <Liste.Content>
        {/* -70px la hauteur de la barre de recherche + titre*/}
        <div
          {...(_.isNil(typeRecensement)
            ? {
                style: { height: 'calc(100% - 130px)' },
              }
            : { style: { height: 'calc(100% - 50px)' } })}
        >
          <RecenseListeTable
            mode={mode}
            simplified={simplified}
            items={recenses}
            loading={loading}
            count={count}
            perPage={perPage}
            onLoad={onLoad}
            onSort={onSort}
            onSelect={onSelect}
            typeRecensement={typeRecensement}
            displayRecensement={displayRecensement}
          />
        </div>
      </Liste.Content>
    </Liste>
  );
};

export default RecenseListe;
